import { createSlice } from '@reduxjs/toolkit'

type InitalStateType = {
  sponsored: {}
  isLoading: boolean
  error: null
}
const initialState: InitalStateType = {
  sponsored: {},
  isLoading: false,
  error: null
}

const slice = createSlice({
  name: 'sponsored',
  initialState,
  reducers: {
    // START LOADING
    startSponsorEntityLoading(state) {
      state.isLoading = true
      state.sponsored = {}
    },

    // HAS ERROR
    hasSponsoredEntityError(state, action) {
      state.isLoading = false
      state.error = action.payload
    },

    // GET Legal Entities
    getSponsoredLegalEntitiesSuccess(state, action) {
      state.isLoading = false
      state.sponsored = action.payload
      state.error = null
    },
    //Clear All Entities
    clearSponsoredLegalEntity(state) {
      state.isLoading = false
      state.sponsored = {}
      state.error = null
    }
  }
})

export const { getSponsoredLegalEntitiesSuccess, hasSponsoredEntityError, startSponsorEntityLoading, clearSponsoredLegalEntity } =
  slice.actions

// Reducer
export default slice.reducer
